"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var YoutubeFilled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M19.0324773,6.35825806 C19.8069886,6.5553871 20.4168409,7.13622581 20.6238409,7.87383871 C20.9596972,9.0674447 20.9956818,11.4189619 20.9995373,11.9091564 L20.9951373,12.4060721 C20.9792807,13.2292399 20.9117178,15.1030191 20.6238409,16.1262581 C20.4168409,16.8637742 19.8069886,17.4446129 19.0324773,17.6418387 C17.9626059,17.9148232 14.4382808,17.9797435 12.8225021,17.9951827 L11.5528426,17.9981921 C10.1932045,17.9894608 6.13042644,17.938561 4.96752273,17.6418387 C4.19311364,17.4446129 3.58315909,16.8637742 3.37615909,16.1262581 C3.11109094,15.1840911 3.03280845,13.5208225 3.00968931,12.6205728 L3.00046266,11.9091564 C3.00431815,11.4189619 3.04030276,9.0674447 3.37615909,7.87383871 C3.58315909,7.13622581 4.19311364,6.5553871 4.96752273,6.35825806 C5.94832468,6.10793256 8.99191331,6.03251689 10.7367784,6.00979638 L12.1003987,6.00017628 C12.8624217,6.00223291 17.739602,6.02828353 19.0324773,6.35825806 Z M10,9 L10,15 L16,12 L10,9 Z" })));
};
YoutubeFilled.displayName = 'YoutubeFilled';
exports.default = YoutubeFilled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=YoutubeFilled.js.map